/** Soft cute palettes in sRGB 0–1. */

export function rainColor(mm) {
  // clear → soft cyan → periwinkle → violet
  const t = Math.min(1, Math.sqrt(Math.max(0, mm) / 8));
  return lerp3([0.35, 0.75, 0.95, 0], [0.48, 0.42, 0.95, 0.85], t);
}

export function tempColor(c) {
  // cool blue → mint → soft peach → coral
  const t = Math.min(1, Math.max(0, (c - 5) / 35));
  if (t < 0.5) return lerp3([0.35, 0.55, 0.95, 0.55], [0.55, 0.9, 0.75, 0.55], t * 2);
  return lerp3([0.55, 0.9, 0.75, 0.55], [0.98, 0.55, 0.45, 0.7], (t - 0.5) * 2);
}

function lerp3(a, b, t) {
  return [
    a[0] + (b[0] - a[0]) * t,
    a[1] + (b[1] - a[1]) * t,
    a[2] + (b[2] - a[2]) * t,
    a[3] + (b[3] - a[3]) * t,
  ];
}

export function rgbaCss(c) {
  return `rgba(${Math.round(c[0] * 255)},${Math.round(c[1] * 255)},${Math.round(c[2] * 255)},${c[3].toFixed(3)})`;
}
